import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = {
  key: 1,
  class: "w-4/5 text-gray-lp-300"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M7.155 2.155c.312-.313.736-.488 1.178-.488h3.334c.442 0 .866.175 1.178.488.313.312.488.736.488 1.178V5h3.334c.46 0 .833.373.833.833 0 .46-.373.834-.833.834h-.058l-.667 9.344c-.045.63-.327 1.22-.79 1.652-.462.43-1.071.67-1.704.67H6.552c-.633 0-1.241-.24-1.704-.67-.463-.431-.745-1.021-.79-1.652l-.667-9.344h-.058c-.46 0-.833-.373-.833-.834 0-.46.373-.833.833-.833h3.334V3.333c0-.442.175-.866.488-1.178zM8.333 5h3.334V3.333H8.333V5zM5.062 6.667l.658 9.225c.015.21.11.407.264.551.154.144.357.224.568.224h6.896c.211 0 .414-.08.568-.224.155-.144.249-.34.264-.55l.658-9.226H5.062zm3.271 1.666c.46 0 .834.373.834.834v5c0 .46-.373.833-.834.833-.46 0-.833-.373-.833-.833v-5c0-.46.373-.834.833-.834zm3.334 0c.46 0 .833.373.833.834v5c0 .46-.373.833-.833.833-.46 0-.834-.373-.834-.833v-5c0-.46.373-.834.834-.834z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = {
  key: 1,
  class: "flex"
}
const _hoisted_5 = {
  class: "w-8",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalShowImage = _resolveComponent("ModalShowImage")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      (_ctx.fileOriginal && !_ctx.isDataValidate)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            onDragover: _cache[4] || (_cache[4] = e => _ctx.setDragAndDrop(e, true)),
            onDragleave: _cache[5] || (_cache[5] = e => _ctx.setDragAndDrop(e, false)),
            onDrop: _cache[6] || (_cache[6] = e => _ctx.onSubmitDrag(e)),
            class: 
        `my-2 flex flex-row justify-between items-center ${
          _ctx.pdfName ? 'border-2 border-dashed rounded px-4 py-2' : ''
        }`
      
          }, [
            (!_ctx.pdfName)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  src: _ctx.fileOriginal,
                  onClick: _cache[1] || (_cache[1] = () => _ctx.onOpenShowImage(true)),
                  class: "\n          h-40 w-3/4 object-cover rounded mr-2 cursor-pointer\n        ",
                  alt: ""
                }, null, 8, ["src"]))
              : (_openBlock(), _createBlock("div", _hoisted_2, _toDisplayString(_ctx.ellipsisString(_ctx.pdfName)), 1)),
            _createVNode("div", null, [
              _createVNode("button", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$refs.file.click())),
                class: "text-12px xxl:text-14px rounded border border-gray-lp-400 text-black-lp-300 font-semibold whitespace-no-wrap px-4 py-2 mr-2 hover:text-white hover:bg-gray-lp-500 focus:outline-none"
              }, " Ubah File ")
            ]),
            (_openBlock(), _createBlock("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              class: "w-5 cursor-pointer text-gray-lp-600 hover:text-gray-lp-800",
              fill: "none",
              viewBox: "0 0 20 20",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.setDefault && _ctx.setDefault(...args)))
            }, [
              _hoisted_3
            ]))
          ], 34))
        : (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode("div", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$refs.file.click())),
              onDragover: _cache[8] || (_cache[8] = e => _ctx.setDragAndDrop(e, true)),
              onDragleave: _cache[9] || (_cache[9] = e => _ctx.setDragAndDrop(e, false)),
              onDrop: _cache[10] || (_cache[10] = e => _ctx.onSubmitDrag(e)),
              class: 
          `flex justify-center cursor-pointer items-center text-12px border-2 border-dashed rounded-lg my-2 p-8 ${
            _ctx.isDragFile
              ? 'border-gray-lp-600 bg-gray-lp-100'
              : _ctx.isDataValidate
              ? 'border-red-lp-1000'
              : 'border-gray-lp-400'
          }`
        
            }, [
              (_openBlock(), _createBlock("svg", _hoisted_5, [
                _createVNode("path", {
                  fill: !_ctx.isDataValidate ? '#D4D5D8' : '#e71c1c',
                  "fill-rule": "evenodd",
                  d: "M12 5c.552 0 1 .448 1 1v5h5c.552 0 1 .448 1 1s-.448 1-1 1h-5v5c0 .552-.448 1-1 1s-1-.448-1-1v-5H6c-.552 0-1-.448-1-1s.448-1 1-1h5V6c0-.552.448-1 1-1z",
                  "clip-rule": "evenodd"
                }, null, 8, ["fill"])
              ]))
            ], 34)
          ])),
      _createVNode("input", {
        type: "file",
        ref: "file",
        onChange: _cache[11] || (_cache[11] = e => (_ctx.isDragFile ? _ctx.onSubmitDrag(e) : _ctx.onSubmitClick(e))),
        accept: 
        `image/png, image/jpeg, ${
          _ctx.typeCustom === 'pdf' ? 'application/pdf' : ''
        }`
      ,
        class: "hidden"
      }, null, 40, ["accept"]),
      _createVNode("p", {
        class: 
        `py-2 text-12px ${
          _ctx.isDataValidate ? 'text-red-lp-1000' : 'text-gray-lp-500'
        }`
      
      }, _toDisplayString(_ctx.caption), 3),
      _withDirectives(_createVNode("p", { class: "text-12px text-red-lp-1000" }, " Pastikan kembali format file sesuai dan ukuran file tidak lebih dari " + _toDisplayString(_ctx.maxSize) + " MB ", 513), [
        [_vShow, _ctx.isDataValidate]
      ])
    ]),
    _withDirectives(_createVNode(_component_ModalShowImage, {
      onClose: () => _ctx.onOpenShowImage(false),
      image: _ctx.fileOriginal
    }, null, 8, ["onClose", "image"]), [
      [_vShow, _ctx.isShow]
    ])
  ], 64))
}